module.exports = __webpack_public_path__ + "static/img/hiragana_large_gi-compressor.93e326b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/hiragana_large_gi-compressor.gif
// module id = k/Fn
// module chunks = 0